function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "81",
  viewBox: "0 0 82 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "6",
  width: "80.333",
  height: "13",
  rx: ".5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7E86A0",
  strokeLinecap: "round",
  d: "M4.5 9v7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 12.513c0-.544.103-1.064.308-1.558.205-.494.482-.92.83-1.28.352-.361.771-.647 1.26-.858A3.89 3.89 0 0111.95 8.5c.735 0 1.417.165 2.044.496.632.33 1.136.793 1.514 1.388.378.592.567 1.25.567 1.973 0 .226-.018.454-.054.683-.035.23-.098.462-.187.697a2.615 2.615 0 01-.322.616c-.125.175-.288.32-.49.433-.203.113-.428.17-.675.17-.178 0-.342-.023-.49-.068a1.258 1.258 0 01-.416-.205.975.975 0 01-.295-.41 1.655 1.655 0 01-.107-.626V12.47c0-.334-.114-.613-.344-.84a1.136 1.136 0 00-.834-.343c-.328 0-.607.114-.84.344-.229.226-.343.505-.343.839 0 .321.116.597.348.826.232.229.51.343.835.343.31 0 .61-.145.901-.437v.777a1.521 1.521 0 01-.901.308c-.503 0-.935-.177-1.295-.531a1.753 1.753 0 01-.536-1.286c0-.506.179-.938.536-1.295.36-.357.792-.536 1.295-.536.485 0 .904.168 1.258.505.36.342.55.756.568 1.24v1.327c0 .402.22.602.66.602a.773.773 0 00.447-.133c.13-.09.233-.201.308-.335a2 2 0 00.187-.478c.05-.184.084-.357.098-.518a4.54 4.54 0 00.027-.49c0-.456-.094-.885-.281-1.287a3.047 3.047 0 00-.75-1.022c-.316-.28-.685-.5-1.107-.66a3.699 3.699 0 00-1.326-.242c-.458 0-.893.09-1.304.268a3.181 3.181 0 00-1.049.719 3.34 3.34 0 00-.692 1.071c-.17.414-.254.85-.254 1.308 0 .614.144 1.176.433 1.688.289.509.684.91 1.187 1.205a3.275 3.275 0 001.679.442h.21v.652h-.21a3.938 3.938 0 01-1.554-.313 3.88 3.88 0 01-1.259-.848 3.972 3.972 0 01-.83-1.268A3.997 3.997 0 018 12.513z",
  fill: "#7E86A0"
}), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: "6",
  width: "80.333",
  height: "13",
  rx: ".5",
  stroke: "#D2D6DB"
}), /*#__PURE__*/React.createElement("rect", {
  y: ".5",
  width: "25.417",
  height: "3",
  rx: "1",
  fill: "#D2D6DB"
})));